"use client";

import dynamic from "next/dynamic";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import SocialProof from "@/components/landing/SocialProof";
import Features from "@/components/landing/Features";
// import PricingTeaser from "@/components/landing/PricingTeaser";

const ProductSnapshots = dynamic(() => import("@/components/landing/ProductSnapshots"), {
  loading: () => <div className="min-h-[520px]" aria-hidden />,
});
const Security = dynamic(() => import("@/components/landing/Security"), {
  loading: () => <div className="min-h-[480px]" aria-hidden />,
});
const About = dynamic(() => import("@/components/landing/About"), {
  loading: () => <div className="min-h-[440px]" aria-hidden />,
});
const CTABand = dynamic(() => import("@/components/landing/CTABand"), {
  loading: () => <div className="min-h-[200px]" aria-hidden />,
});
const Footer = dynamic(() => import("@/components/landing/Footer"), {
  loading: () => <div className="min-h-[280px]" aria-hidden />,
});

export default function LandingPage() {
  return (
    <div className="relative min-h-screen flex flex-col bg-background">
      <div className="landing-ambient" aria-hidden />
      <Header />
      <main className="relative z-10 flex-1">
        <Hero />
        <div className="landing-defer-paint">
          <SocialProof />
        </div>
        <div className="landing-defer-paint">
          <Features />
        </div>
        {/* <PricingTeaser /> */}
        <div className="landing-defer-paint">
          <ProductSnapshots />
        </div>
        <div className="landing-defer-paint">
          <Security />
        </div>
        <div className="landing-defer-paint">
          <About />
        </div>
        <div className="landing-defer-paint">
          <CTABand />
        </div>
      </main>
      <div className="landing-defer-paint">
        <Footer />
      </div>
    </div>
  );
}
